export default "__VITE_ASSET__gzsaawuV__"